export class VnaPortalAppSelected {
    portal: string;

    constructor(portal: string) {
        this.portal = portal;
    }

    getPortal(): string {
        return this.portal;
    }
}


// WEBPACK FOOTER //
// /var/www/backend/src/app/core/data/messaging/VnaPortalAppSelected.ts